import styles from './WaveDivider.module.scss';

interface WaveDividerProps {
  from?: 'yellow' | 'magenta' | 'dark';
  flip?: boolean;
}

export default function WaveDivider({ from = 'yellow', flip = false }: WaveDividerProps) {
  return (
    <div
      className={`${styles.wave} ${styles[from]} ${flip ? styles.flip : ''}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0,40 C360,100 720,0 1080,60 C1260,80 1380,40 1440,50 L1440,100 L0,100 Z" />
      </svg>
    </div>
  );
}
